import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cardShadow } from "@/lib/ui";

export function ServiceCard({ service, index = 0 }) {
  const Icon = service.icon;
  return (
    <article
      className={`group flex flex-col overflow-hidden rounded-2xl bg-white border border-gray-100 ${cardShadow} transition-transform duration-300 hover:-translate-y-1`}
      data-testid={`service-card-${service.slug}`}
      style={{ animationDelay: `${index * 40}ms` }}
    >
      <div className="relative h-44 overflow-hidden">
        <img
          src={service.image}
          alt={`${service.title} in Melbourne`}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-navy/40 to-transparent" />
        <span className="absolute top-3 left-3 grid place-items-center w-11 h-11 rounded-xl bg-white/95 backdrop-blur shadow-md">
          <Icon className="w-5 h-5 text-navy" strokeWidth={2} />
        </span>
      </div>
      <div className="flex flex-col flex-1 p-6">
        <h3 className="font-heading text-lg font-semibold text-navy">{service.title}</h3>
        <p className="mt-2 text-sm text-gray-600 leading-relaxed flex-1">{service.short}</p>
        <div className="mt-5 flex items-center gap-3">
          <Link
            to={`/services/${service.slug}`}
            className="inline-flex items-center gap-1 text-sm font-semibold text-navy hover:text-brandgreen transition-colors"
            data-testid={`service-learn-${service.slug}`}
          >
            Learn More <ArrowRight className="w-4 h-4" />
          </Link>
          <span className="text-gray-200">|</span>
          <Link
            to={`/quote?service=${encodeURIComponent(service.title)}`}
            className="inline-flex items-center rounded-full bg-brandgreen/10 px-4 py-1.5 text-sm font-semibold text-brandgreen-dark hover:bg-brandgreen hover:text-white transition-colors"
            data-testid={`service-quote-${service.slug}`}
          >
            Get Quote
          </Link>
        </div>
      </div>
    </article>
  );
}
